import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { IMAGE_SIZE_CODE } from '../../../../constants/image-size-codes';
import { getThumbBySize } from '../../../../util/photo';

const propTypes = {
  photo: PropTypes.shape({
    id: PropTypes.string.isRequired,
    thumbnail_urls: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string.isRequired,
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
        size_code: PropTypes.oneOf(Object.values(IMAGE_SIZE_CODE)).isRequired,
      }).isRequired,
    ).isRequired,
  }).isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
};

const CartItemPhotoPreview = ({ photo, className, children }) => {
  const classes = classNames({
    'checkout-cart-item-photo': true,
    [className]: !!className,
  });

  const isEntitled =
    typeof photo?.is_entitled_matched_photo === 'undefined' ||
    photo?.is_entitled_matched_photo;

  return (
    <div className={classes}>
      <img
        src={
          getThumbBySize(photo?.thumbnail_urls, IMAGE_SIZE_CODE.SMALL2X)?.url
        }
        className="checkout-cart-item-photo-img"
        alt=""
      />
      {!isEntitled && (
        <div className="checkout-cart-item-photo-preview-label-watermark" />
      )}

      {children}
    </div>
  );
};

CartItemPhotoPreview.propTypes = propTypes;

export default CartItemPhotoPreview;
